import { mapState, mapActions } from 'vuex'
import { obterImagem } from '@/util/imagem'
import util from '@/util'
import mensagens from '@/util/mensagens'

const formasPagamentoMixins = {
  computed: {
    ...mapState('formaspagamento', ['estaCadastrandoCartao', 'formularioFormaDePagamentoCliente'])
  },
  methods: {
    async atualizarFormaPagamento (value) {
      this.$emit('atualizarId', null)

      this.pagamentoSelecionado = value

      this.selecionarMetodoPagamento()
      this.$emit('formaPagamento', this.formulario.forma_pagamento)
      this.ActionDefinirEstaCadastrandoCartao(false)

      if (this.cartoes.length > 0) {
        const cartaoEncontrado = this.cartoes.findIndex(cartao => cartao.selecionado)
        this.selecionarCartao(cartaoEncontrado !== -1 ? cartaoEncontrado : 0)
        this.$emit('atualizarId', this.cartoes.find(cartao => cartao.selecionado).id)
      }
    },
    async excluirCartao (cartao) {
      try {
        this.isLoadingCartao = true
        this.isLoading = true

        const resposta = await this.axios.get(`/manager/conta/cartao/${cartao}/excluir`)
        if (resposta.data.retorno.sucesso) {
          await this.obterCartoes()
          this.$emit('atualizarId', this.cartoes.find(cartao => cartao.selecionado).id)
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Cartão excluído com sucesso!')
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        }
        this.isLoadingCartao = false
        this.isLoading = false
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
        this.isLoadingCartao = false
        this.isLoading = false
      }
    },
    async obterCartoes (pegarUltimoCartao = false) {
      try {
        this.isLoadingCartao = true
        const resposta = await this.axios.get(`/manager/conta/cartoes`, this.dadosFormulario)
        this.cartoes = resposta.data.retorno.dados

        if (this.cartoes.length > 0) {
          if (!pegarUltimoCartao) {
            this.cartoes = resposta.data.retorno.dados.map(cartao => {
              if (cartao.padrao) {
                cartao.selecionado = true
              } else {
                cartao.selecionado = false
              }
              return cartao
            })
          } else {
            this.cartoes = resposta.data.retorno.dados.map(cartao => {
              cartao.selecionado = false
              return cartao
            })

            if (this.cartoes.length > 0) {
              this.cartoes[this.cartoes.length - 1].selecionado = true
            }
          }
          if (this.cartoes.find(cartao => cartao.selecionado) !== undefined) {
            this.$emit('atualizarId', this.cartoes.find(cartao => cartao.selecionado).id)
          } else {
            this.$emit('atualizarId', this.cartoes[0].id)
          }
        }
        this.isLoadingCartao = false
      } catch (e) {
        this.isLoadingCartao = false
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },
    async cadastrarCartao () {
      this.listaDeErros = {}
      this.isLoadingCartao = true
      try {
        this.definirDebitoAutomaticoDefault()
        this.formulario.escritorio.cartao.padrao = this.cartaoPadrao
        this.formulario.forma_pagamento = this.formularioFormaDePagamentoCliente.forma_pagamento_idselecionado
        const resposta = await this.axios.post(`/manager/conta/cartao`, { escritorio: this.formulario.escritorio, forma_pagamento: this.formulario.forma_pagamento, pagamento_automatico: this.formularioFormaDePagamentoCliente.pagamento_automatico })
        if (resposta.data.retorno.sucesso) {
          await this.obterCartoes()

          this.ActionDefinirEstaCadastrandoCartao(false)
          this.bandeiraDoCartao = null
          this.cartaoPadrao = false

          this.formulario.escritorio.cartao.nome_cartao = null
          this.formulario.escritorio.cartao.numero_cartao = null
          this.formulario.escritorio.cartao.validade_cartao = null
          this.formulario.escritorio.cartao.ccv_cartao = null
          this.formulario.escritorio.cartao.bandeira = null
          this.formulario.escritorio.cartao.id = null
          this.formulario.escritorio.cartao.cpf_cnpj = null

          this.$emit('atualizarId', this.cartoes.find(cartao => cartao.selecionado).id)

          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Cartão inserido com sucesso!')
        } else {
          this.isLoading = false
          for (let campoErro of Object.keys(resposta.data.retorno.listaDeErros)) {
            this.$set(this.listaDeErros, campoErro, resposta.data.retorno.listaDeErros[campoErro])
          }
          util.criarAlertaToastDeErro(this, 'Aviso', resposta.data.retorno.mensagem)
        }
        this.isLoadingCartao = false
      } catch (e) {
        this.isLoadingCartao = false
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
    },
    definirDebitoAutomaticoDefault () {
      const ehPrimeiroCadastroCartao = this.cartoes.length === 0
      if (!ehPrimeiroCadastroCartao) return

      this.formularioFormaDePagamentoCliente.pagamento_automatico = true
    },
    definirCartaoPadrao (cartao) {
      this.cartaoPadrao = cartao
    },
    definirFormulario (formulario) {
      this.formulario = formulario
    },
    selecionarCartao (index) {
      this.cartoes = this.cartoes.map(cartao => {
        cartao.selecionado = false

        if (this.formularioFormaDePagamentoCliente.filho === 'forma_pagamento') {
          cartao.padrao = false
        }

        return cartao
      })

      this.cartoes[index].selecionado = true

      if (this.formularioFormaDePagamentoCliente.filho === 'forma_pagamento') {
        this.cartoes[index].padrao = true

        this.ActionDefinirFormaPagamentoCliente({
          cartao_selecionado_padrao: this.cartoes[index].id
        })
      }

      this.$emit('atualizarId', this.cartoes.find(cartao => cartao.selecionado).id) // Esse emit é configurado dentro do Carrinho.vue
    },
    selecionarMetodoPagamento () {
      this.formulario.forma_pagamento = this.pagamentoSelecionado ? this.encontrarIdDoMetodoDePagamentoPeloNome(this.pagamentoSelecionado) : null
    },
    encontrarIdDoMetodoDePagamentoPeloNome (nomeMetodo) {
      return this.formasDePagamento.find(formaPagamento => formaPagamento.nome === nomeMetodo)?.id || null
    },
    obterBandeira (cartao) {
      return obterImagem(`bandeiras/${cartao.bandeira}`)
    },
    obterBandeiraInput (bandeira) {
      return obterImagem(`bandeiras/${bandeira}`)
    },
    determinarBandeiraDoCartao () {
      const numeroDoCartao = this.formulario.escritorio.cartao.numero_cartao.replace(/\D/g, '')
      const filtroPorNumeroCartao = (numero, bandeira) => bandeira.regex.test(numero)
      const bandeiraEncontrada = this.obterBandeiraCartaoPorFiltro(numeroDoCartao, filtroPorNumeroCartao)
      this.bandeiraDoCartao = bandeiraEncontrada?.nome ?? 'sem_bandeira.svg'
      this.formulario.escritorio.cartao.bandeira = this.bandeiraDoCartao
    },
    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },
    ...mapActions('formaspagamento', ['ActionDefinirEstaCadastrandoCartao', 'ActionDefinirFormaPagamentoCliente'])
  }
}

export { formasPagamentoMixins }
